import CustomStorage from '@glenngijsberts/customstorage';
import axios from 'axios';
import keys from '../keys';

function getAuth() {
    return CustomStorage.get('auth') || '{}';
}

function getUser() {
    const auth = getAuth();
    if (auth.user) return auth.user;

    return null;
}

function getUserType() {
    const auth = getAuth();
    let type = null;

    if (auth.user) {
        switch (auth.user.user_type) {
        case 'admin':
            type = 'admin';
            break;

        case 'reseller':
            type = 'reseller';
            break;

        case 'client':
            type = 'client';
            break;

        default:
            type = null;
        }
    }

    return type;
}

function getHeaders(token) {
    return {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'X-localization': 'nl_NL',
        'X-fqdn': window.location.hostname,
        'X-Requested-With': 'XMLHttpRequest',
    };
}

function getToken() {
    const auth = getAuth();
    if (auth) return auth.access_token;

    return false;
}

function getRefreshAt() {
    const auth = getAuth();
    if (auth.refresh_at) {
        return auth.refresh_at;
    }

    return 0;
}

function refreshToken() {
    return new Promise((resolve, reject) => {
        const headers = getHeaders(getToken());

        axios({
            method: 'POST',
            url: `${keys.API_URL}/api/auth/refresh`,
            headers,
        })
            .then(response => {
                const auth = getAuth();
                const now = new Date().getTime() / 1000;

                auth.access_token = response.data.access_token;
                auth.expires_in = response.data.expires_in;
                auth.token_type = response.data.token_type;
                auth.refresh_at = now + response.data.expires_in - 1200;

                CustomStorage.set('auth', auth, response.data.expires_in / 60);
                resolve();
            })
            .catch(error => {
                reject(error);
            });
    });
}

function isAuthorized() {
    return getToken();
}

function logout(url) {
    // clears localstorage (tokens)
    CustomStorage.remove('auth');
    // Redirect to login
    window.location.href = url;
}

export {
    getToken, getAuth, getHeaders, getUser, getRefreshAt, refreshToken, logout, getUserType,
};

export default isAuthorized;
